import React from 'react';
import { ISourceDefinition } from '@stores/sourceDefinitionsList';
import Loading from '@ui-library/Loading';
import { JSONSchema } from '@components/common/jsonSchemaForm/jsonSchemaForm';
import { SourceNameInputContainer as Container } from '../styles';
import { ResourceSelection } from '../cloudSource/resourceSelection/ResourceSelection';
import classes from './style.module.scss';
import { useResources } from './hooks';
import { Resource } from '../cloudSource/cloudSourceSettings';
import { transformResourceList } from './utils';

interface ISingerSourceConfigProps {
  sourceDefinition: ISourceDefinition;
  onChange: (
    streams: { streams: CatalogAsConfig[] },
    catalog: Catalog[],
    resources: Resource[],
  ) => void;
  config?: unknown;
  selectedResources?: string[] | undefined;
  onSingleResourceOrLess?: () => void;
  catalog?: Catalog[];
  disabled?: boolean;
  configJSONSchema?: JSONSchema;
}
export interface CatalogAsConfig {
  stream: Catalog;
  sync_mode: string;
  primary_key?: string[][];
  destination_sync_mode: string;
}

export interface Catalog {
  name: string;
  json_schema: {
    $schema: string;
    name: string;
    type: string;
    properties: unknown;
  };
  supported_sync_modes: string[];
  source_defined_cursor: boolean;
  default_cursor_field: string[];
  source_defined_primary_key: string[][];
}
const transformSelectedResources = (
  resources: string[],
  catalog: Catalog[],
): { streams: CatalogAsConfig[] } => {
  const streams = resources.map((resourceName) => {
    const currentCatalogItem = catalog.find((item) => resourceName === item.name);

    const syncMode = currentCatalogItem?.supported_sync_modes?.includes('incremental')
      ? 'incremental'
      : currentCatalogItem?.supported_sync_modes[0];
    const primaryKey = currentCatalogItem?.source_defined_primary_key?.[0]?.[0];

    return {
      stream: currentCatalogItem as Catalog,
      sync_mode: syncMode as string,
      primary_key: primaryKey ? [[primaryKey as string]] : undefined,
      destination_sync_mode: 'append_dedup' as string,
    };
  });
  return {
    streams,
  };
};

const SingerResourceSelection = (props: ISingerSourceConfigProps) => {
  const { catalog, loading } = useResources({
    image: props.sourceDefinition.options?.image,
    config: props.config!,
    defaultCatalog: props.catalog,
    sourceDefinitionName: props.sourceDefinition.name,
    configJSONSchema: props.configJSONSchema,
  });

  if (!catalog && !loading) {
    return null;
  }
  const displayableResources = catalog?.map((item) => ({
    name: item.name,
    resource: item.name,
    default: true,
  }));
  return (
    <Container className={`p-t-lg p-b-lg configure-data__container ${classes.resourcesContainer}`}>
      {loading ? (
        <Loading size={64} />
      ) : (
        <ResourceSelection
          selectedResources={props.selectedResources}
          onSingleResourceOrLess={props.onSingleResourceOrLess}
          availableResources={displayableResources || []}
          onChange={(resources) => {
            const data = transformSelectedResources(resources, catalog);
            const resourceList = transformResourceList(resources);
            props.onChange(data, catalog, resourceList);
          }}
          disabled={props.disabled}
        />
      )}
    </Container>
  );
};
export default SingerResourceSelection;
